import React from "react";
import RemarksCard from "./remarksCard/RemarksCard";
import "./Remarks.css";
import { Paper } from "@material-ui/core";
import { IRemarks } from "../../../../../types/remarks.types";

const Remarks = ({ remarks_list }: { remarks_list: IRemarks[] }) => {
	return (
		<Paper elevation={2} style={{ marginTop: 2, padding: 20 }}>
			{remarks_list?.map((remark, index) =>
				remark.EXPLCD01 === 0 && remark.EXPLCD02 === 0 && remark.EXPLCD03 === 0 ? null : (
					<RemarksCard key={index} remark={remark} index={index} />
				)
			)}
		</Paper>
	);
};

export default Remarks;
